/*
  検索結果ページ（allproduct）のロジック本体。
  Liquidが必要な部分（商品データ・用途タグ・種類タグ）は
  window.SEARCH_PAGE_DATA としてテーマ側の<script>から渡される。

  このファイルと allproduct のカスタムLiquid（確定版44）は対になっている。
  片方だけ差し替えると動かなくなるので、必ず両方を揃えること。

  ── 今回の修正（不具合）──
  ・モーダルでカテゴリタブを切り替えただけで、検索結果側のカテゴリ（state.cat）まで
    切り替わっていた。「この条件で探す」を押さずに閉じたあと、条件チップの×・
    「すべて解除」・「用途で絞る」を押すと、そのカテゴリで絞り込み直されていた。
    → タブ（モーダルで開いているカテゴリ）は uiTab として別に持ち、
      state.cat は「この条件で探す」を押したときだけ変える。
  ・検索せずに閉じたあと開き直すと、別のタブが開いたままになっていた。
    → モーダルを開くたびに、検索結果に出ているカテゴリのタブに戻し、
      そのタブのチェックと期間も、検索結果に適用中の条件に戻す。
      （検索結果が無い初期表示では何もしない）
  ・allproduct のLiquidは変更なし（確定版44のまま）。

  ── 確定版44と対の修正 ──
  ・プランカード（planCardHtml）をプラン一覧セクションに揃えた。
    ・追加：カテゴリバッジ（cols / colTitles から判定）、日本語アテンド付き（attend）、
      キャッチ（catchText）、おすすめ（reco）、撮影カット数・データ・衣裳（points）
    ・並び順：タイトル → バッジ → 写真 → キャッチ → おすすめ → 撮影内容 → 規定 → 価格
    ・規定と価格を .plan-card-bottom で囲み、高さ揃えの余白をその上で吸わせる
  ・オプションカードは変更していない。

  ── 確定版43と対の修正 ──
  ・オプションカード（productCardHtml）に二重価格（取り消し線）を追加した。
    priceDisplayFor() が返す compareText をそのまま使うので、
    判定はプランカードと同じ（最低価格のバリエーションのセール前価格が価格より高いときだけ）。
    price_override がある商品は従来どおり取り消し線なし。
    価格を .price-box で囲み、その中に .compare-text と .price-text を置く。
    見た目と位置揃えのCSSは allproduct のLiquid側にある。

  ── 以前の修正 ──
  ・DOMContentLoaded 内で #category-menu / .search-panel を参照していたのを
    switchSearchCategory() に置き換えた。
    確定版38でUIがモーダル＋カテゴリタブ（.sr-cat-tab / .sr-cat-pane）に
    変わり、#category-menu が存在しなくなっていたため、
    cat付きURLで来ると null 参照でスクリプトが停止し、
    applyFilters() まで到達せず結果が0件のままになっていた。
  ・selectCategory() / backToCategories() も同じ理由で作り直した
    （新UIには「カテゴリ選択に戻る」概念が無いため、後者は何もしない）。
  ・プランカードをプラン一覧セクション（子コレクションページ）と同じ形にした。
    ・写真をドット切り替え→横スクロール（.plan-card-strip）
    ・キャンセル規定のアコーディオンを廃止し、plan_agreement_up の1行固定に
      （プラン一覧側と同じ扱い。agreeDown は使わない）
  ・ドット切り替え用のクリックハンドラを削除した。
  ・プランカードの二重価格（compareAt / compareText / .plan-card-compare）

  ── 期間絞り込み ──
  商品オプション「期間」のバリエーション値をLiquid側が periods として渡す。
  表記例：2026年4月-9月／2026年4月-9月（平日）／2026年12月（土日祝）
  括弧の中は dayType として保持しているが、現在は絞り込みに使っていない。
  選んだ月に該当するバリエーションのうち最安値を表示し、
  価格が複数あれば「〜」を付ける（＝平日価格が出る）。
*/
(function () {
  const DATA = window.SEARCH_PAGE_DATA || {};
  const allProducts = DATA.allProducts || [];
  const currentHandle = DATA.currentHandle || '';
  const PRICE_LABEL = DATA.priceLabel || '';

  const parentHandles = ['photowedding', 'wedding', 'anniversary'];
  const islandTags = ['本島', '宮古島'];

  /* ============================================================
     期間絞り込みの設定
     ============================================================ */
  // 期間オプションを持たない商品を、月を選んだときに残すかどうか。
  // 現在は全プランに期間があるため false（＝残さない）。
  const INCLUDE_PRODUCTS_WITHOUT_PERIOD = false;
  const PERIOD_RE = /^\s*(\d{4})年\s*(\d{1,2})月\s*(?:[-–—~〜ー－]\s*(?:(\d{4})年\s*)?(\d{1,2})月\s*)?(?:[（(]\s*(.+?)\s*[)）]\s*)?$/;

  // 用途タグ・種類タグの定義
  const USE_TAGS = (DATA.useTags && DATA.useTags.length > 0)
    ? DATA.useTags
    : ['フォトオプション', '挙式オプション', 'アニバーサリーオプション'];

  const USE_LABELS = {
    'フォトオプション': 'フォト用',
    '挙式オプション': '挙式用',
    'アニバーサリーオプション': 'アニバーサリー用'
  };
  const USE_CLASSES = {
    'フォトオプション': 'tag-use-photo',
    '挙式オプション': 'tag-use-wedding',
    'アニバーサリーオプション': 'tag-use-anniv'
  };

  const TYPE_TAGS = (DATA.typeTags && DATA.typeTags.length > 0)
    ? DATA.typeTags
    : ['アルバム', 'フォトグラファー指名', 'フォトツアー', 'ムービー', '美容', 'ブーケ・花関連', 'オプションその他'];
  const TYPE_FALLBACK = 'オプションその他';

  const allAreaTitles = (function () {
    const s = new Set();
    allProducts.forEach(p => {
      p.cols.forEach((h, i) => {
        if (parentHandles.some(ph => h.startsWith(ph + '-'))) s.add(p.colTitles[i]);
      });
    });
    return [...s];
  })();
  const areaTitleSet = new Set(allAreaTitles);

  // state.cat は「検索結果に出ているカテゴリ」。「この条件で探す」を押したときだけ変わる
  const state = { cat: null, areas: [], groups: [], months: [], planHandle: null, planTitle: '', planOptHandles: [], planLoading: false };
  // モーダルで開いているカテゴリタブ。state.cat とは別に持つ
  let uiTab = null;
  const pendingByCat = {};

  function pendingFor(cat) {
    if (!cat) return [];
    if (!pendingByCat[cat]) pendingByCat[cat] = [];
    return pendingByCat[cat];
  }

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ============================================================
     年月コードのユーティリティ & 過去月除外判定
     ============================================================ */
  function pad2(n) { return String(n).padStart(2, '0'); }
  function ymCode(y, m) { return y + '-' + pad2(m); }
  function ymLabel(code) {
    const parts = code.split('-');
    return parts[0] + '年' + parseInt(parts[1], 10) + '月';
  }
  function ymShortLabel(code) {
    return parseInt(code.split('-')[1], 10) + '月';
  }
  function ymYear(code) { return code.split('-')[0]; }
  function isYmCode(s) { return /^\d{4}-\d{2}$/.test(String(s || '')); }

  // 今月以降かどうかを判定する（今日より前の月は選択肢に出さない）
  function isCurrentOrFutureYm(code) {
    const now = new Date();
    const currentYm = ymCode(now.getFullYear(), now.getMonth() + 1);
    return code >= currentYm;
  }

  function expandMonths(sy, sm, ey, em) {
    const out = [];
    let y = sy, m = sm;
    let guard = 0;
    while ((y < ey || (y === ey && m <= em)) && guard < 120) {
      const code = ymCode(y, m);
      if (isCurrentOrFutureYm(code)) {
        out.push(code);
      }
      m += 1;
      if (m > 12) { m = 1; y += 1; }
      guard += 1;
    }
    return out;
  }

  function parsePeriod(value) {
    const m = String(value || '').match(PERIOD_RE);
    if (!m) return null;
    const sy = +m[1], sm = +m[2];
    let ey = m[3] ? +m[3] : sy;
    const em = m[4] ? +m[4] : sm;
    // 「2026年12月-2月」のように終了月が開始月より小さい場合は翌年をまたぐ
    if (!m[3] && em < sm) ey = sy + 1;
    return {
      raw: value,
      months: expandMonths(sy, sm, ey, em),
      dayType: m[5] ? m[5].trim() : null
    };
  }

  allProducts.forEach(p => {
    const src = Array.isArray(p.periods) ? p.periods : [];
    const out = [];
    src.forEach(v => {
      const parsed = parsePeriod(v.v);
      if (!parsed || parsed.months.length === 0) return;
      out.push({
        months: parsed.months,
        monthSet: new Set(parsed.months),
        dayType: parsed.dayType,
        raw: parsed.raw,
        price: v.p,
        priceF: v.f,
        compareAt: v.c || null,
        compareAtF: v.cf || null,
        available: v.a !== false
      });
    });
    p._periods = out;
  });

  function matchingPeriods(p, months) {
    if (!p._periods || p._periods.length === 0) return [];
    return p._periods.filter(pr => {
      if (!pr.available) return false;
      return months.some(ym => pr.monthSet.has(ym));
    });
  }

  function matchesMonths(p) {
    if (state.months.length === 0) return true;
    if (!p._periods || p._periods.length === 0) return INCLUDE_PRODUCTS_WITHOUT_PERIOD;
    return matchingPeriods(p, state.months).length > 0;
  }

  // エリア判定：子コレクション所属（ハンドル前方一致＋タイトル一致）またはエリア名タグ一致。
  // プラン商品は子コレクションで、オプション商品（エリアタグ運用）はタグで当たる。
  function belongsToArea(p, categoryHandle, areaTitle) {
    const parent = categoryHandle.split('-')[0];
    const prefix = parent + '-';
    const inChildCollection = p.cols.some((h, i) => h.startsWith(prefix) && p.colTitles[i] === areaTitle);
    const hasAreaTag = p.tags.includes(areaTitle);
    return inChildCollection || hasAreaTag;
  }

  function areaBadgeTitles(p) {
    const titlesSet = new Set();
    p.cols.forEach((h, i) => {
      if (parentHandles.some(ph => h.startsWith(ph + '-'))) titlesSet.add(p.colTitles[i]);
    });
    if (titlesSet.size === 0) {
      p.tags.forEach(t => { if (areaTitleSet.has(t)) titlesSet.add(t); });
    }
    return [...titlesSet];
  }

  function useBadgeTags(p) {
    return Object.keys(USE_LABELS).filter(t => p.tags.includes(t));
  }

  // 商品が属する種類を1つだけ決める。TYPE_TAGS 順で最初に一致したものを採用し、
  // 一致が無ければ TYPE_FALLBACK に入れる（重複表示を避け、件数の合計を総件数と一致させる）
  function typeOf(p) {
    for (const t of TYPE_TAGS) {
      if (p.tags.includes(t)) return t;
    }
    return TYPE_FALLBACK;
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  document.addEventListener('DOMContentLoaded', function () {
    const params = new URLSearchParams(window.location.search);
    const cat = params.get('cat');

    initSheet();

    if (cat) {
      state.cat = cat;
      state.areas = (params.get('a') || '').split('|').map(s => s.trim()).filter(Boolean);
      state.groups = params.getAll('f').map(g => g.split('|').map(t => t.trim()).filter(Boolean)).filter(g => g.length > 0);
      state.months = (params.get('ym') || '').split('|').map(s => s.trim()).filter(isYmCode).sort();

      const planParam = params.get('plan');
      if (cat === 'option' && planParam) {
        state.planHandle = planParam;
        state.planTitle = planParam;
        state.planOptHandles = [];
        state.planLoading = true;
        fetchPlanOptions(planParam);
      } else {
        state.planHandle = null;
        state.planTitle = '';
        state.planOptHandles = [];
        state.planLoading = false;
      }

      initPeriodPickers();
      restorePanelState();

      // 該当カテゴリのタブとパネルを開く。
      // 旧UIの #category-menu / .search-panel は存在しないので触らない。
      switchSearchCategory(cat);
    } else {
      initPeriodPickers();
      if (params.get('openFilter') === '1') {
        openSheet();
      }
    }

    applyFilters({ updateUrl: false });

    // 点検パネルは ?debug=1 のときだけ表示する
    if (params.get('debug') === '1') {
      const dbg = document.getElementById('search-debug');
      if (dbg) dbg.hidden = false;
    }
  });

  /* ============================================================
     絞り込みモーダル
     ============================================================ */
  function sheetEl() { return document.getElementById('sr-filter-sheet'); }

  function initSheet() {
    const sheet = sheetEl();
    if (!sheet) return;
    sheet.hidden = false;

    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-sr-close]')) closeSheet();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet.getAttribute('data-open') === '1') closeSheet();
    });
  }

  function openSheet() {
    const sheet = sheetEl();
    if (!sheet) return;
    // 検索結果に出ているカテゴリのタブに戻し、チェックと期間を適用中の条件に戻す
    if (state.cat) {
      restorePanelState();
      switchSearchCategory(state.cat);
    }
    sheet.setAttribute('data-open', '1');
    document.body.classList.add('sr-modal-open');
  }

  function closeSheet() {
    const sheet = sheetEl();
    if (!sheet) return;
    sheet.setAttribute('data-open', '0');
    document.body.classList.remove('sr-modal-open');
  }

  function toggleFilterMenu() {
    const sheet = sheetEl();
    if (!sheet) return;
    if (sheet.getAttribute('data-open') === '1') closeSheet();
    else openSheet();
  }

  // カテゴリタブの切り替え。Liquid側の onclick からも呼ばれる。
  // 期間ブロックはオプションのときだけ隠す（オプションに期間が無いため）。
  // タブを切り替えるだけで、検索結果側のカテゴリ（state.cat）は変えない。
  function switchSearchCategory(handle) {
    document.querySelectorAll('.sr-cat-tab').forEach(function (tab) {
      tab.classList.toggle('is-active', tab.getAttribute('data-target') === 'tab-' + handle);
    });
    document.querySelectorAll('.sr-cat-pane').forEach(function (pane) {
      pane.classList.toggle('is-active', pane.id === 'tab-' + handle);
    });

    const periodWrapper = document.getElementById('global-period-wrapper');
    if (periodWrapper) {
      if (handle === 'option') {
        periodWrapper.style.display = 'none';
      } else {
        periodWrapper.style.display = 'block';
        const periodContainer = document.getElementById('global-period-container');
        if (periodContainer) periodContainer.setAttribute('data-cat', handle);
      }
    }

    uiTab = handle;
    initPeriodPickers();
  }

  // 旧UIとの互換用。新UIではタブ切り替えと同じ動きになる。
  function selectCategory(handle) {
    switchSearchCategory(handle);
  }

  // 旧UIの「カテゴリ選択に戻る」。新UIには該当する画面が無いので何もしない。
  function backToCategories() {}

  function executeAdvancedSearch(handle) {
    const panel = document.getElementById('tab-' + handle);
    if (!panel) return;

    const areaNames = [];
    const filterGroups = [];
    panel.querySelectorAll('.search-group').forEach(g => {
      const checked = Array.from(g.querySelectorAll('input:checked')).map(i => i.value.trim());
      if (checked.length === 0) return;
      if ((g.dataset.groupTitle || '').includes('エリア')) areaNames.push(...checked);
      else filterGroups.push(checked);
    });

    state.cat = handle;
    state.areas = areaNames;
    state.groups = filterGroups;
    state.months = pendingFor(handle).slice().sort();

    closeSheet();
    applyFilters({ scroll: true });
  }

  function restorePanelState() {
    if (state.cat) {
      pendingByCat[state.cat] = state.months.slice();
    }
    initPeriodPickers();

    if (!state.cat) return;
    const panel = document.getElementById('tab-' + state.cat);
    if (!panel) return;
    const wanted = state.areas.concat(state.groups.reduce((a, g) => a.concat(g), []));
    panel.querySelectorAll('input[type="checkbox"]').forEach(cb => {
      cb.checked = wanted.indexOf(cb.value.trim()) !== -1;
    });
  }

  // プラン1件分のオプションhandle一覧を取得する。
  // 他のプランは一切見に行かず、?plan= のプラン1件のページだけを裏側でfetchし、
  // product-options-section.liquid が埋め込んでいる隠しJSONを読み取る。
  function fetchPlanOptions(handle) {
    fetch('/products/' + handle)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const dataEl = doc.getElementById('plan-option-handles');
        if (!dataEl) throw new Error('plan-option-handles not found');
        const data = JSON.parse(dataEl.textContent);
        state.planTitle = data.title || handle;
        state.planOptHandles = Array.isArray(data.handles) ? data.handles : [];
      })
      .catch(function () {
        // 取得に失敗しても画面が固まらないよう、0件表示にフォールバックする
        state.planTitle = handle;
        state.planOptHandles = [];
      })
      .finally(function () {
        state.planLoading = false;
        applyFilters({ updateUrl: false });
      });
  }

  // 絞り込みの単一の出口。フィルタ実行・URL更新・チップ描画・結果描画をまとめる
  function applyFilters(opts) {
    const options = opts || {};
    const updateUrl = options.updateUrl !== false;

    // プラン1件のfetchが終わるまでは、読み込み中の表示だけ出して待つ
    if (state.cat === 'option' && state.planHandle && state.planLoading) {
      const quick = document.getElementById('use-quick-filter');
      const cond = document.getElementById('active-conditions');
      const banner = document.getElementById('plan-context-banner');
      const header = document.getElementById('results-header');
      const nav = document.getElementById('type-nav');
      const container = document.getElementById('search-results-container');
      if (quick) quick.style.display = 'none';
      if (cond) cond.style.display = 'none';
      if (banner) banner.style.display = 'none';
      if (header) header.textContent = '読み込み中…';
      if (nav) nav.style.display = 'none';
      if (container) container.innerHTML = '';
      return;
    }

    let list;
    if (state.cat === 'option' && state.planHandle) {
      // グループモード：fetchで取得したhandle一覧に含まれる商品だけを表示する。
      // タグ・エリアによる絞り込みは行わない（登録＝表示対象という前提のため）。
      const planHandleSet = new Set(state.planOptHandles);
      list = allProducts.filter(p => planHandleSet.has(p.handle));

      if (updateUrl) {
        const params = new URLSearchParams();
        params.set('cat', 'option');
        params.set('plan', state.planHandle);
        history.replaceState(null, '', window.location.pathname + '?' + params.toString());
      }
    } else if (state.cat) {
      list = allProducts.filter(p => {
        const inCat = p.cols.includes(state.cat);
        const matchArea = state.areas.length > 0 ? state.areas.some(a => belongsToArea(p, state.cat, a)) : true;
        const matchFilters = state.groups.every(g => g.some(t => p.tags.includes(t)));
        return inCat && matchArea && matchFilters && matchesMonths(p);
      });

      if (updateUrl) {
        const params = new URLSearchParams();
        params.set('cat', state.cat);
        if (state.areas.length > 0) params.set('a', state.areas.join('|'));
        state.groups.forEach(group => params.append('f', group.join('|')));
        if (state.months.length > 0) params.set('ym', state.months.join('|'));
        history.replaceState(null, '', window.location.pathname + '?' + params.toString());
      }
    } else {
      list = allProducts.filter(p => p.cols.includes(currentHandle) && matchesMonths(p));
    }

    renderPlanBanner();
    renderQuickFilter();
    renderActiveConditions();
    renderResults(list);

    if (options.scroll) {
      const wrap = document.getElementById('results-wrapper');
      if (wrap) wrap.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth' });
    }
  }

  /* ============================================================
     年月チップ（カテゴリごとの期間を生成 ＆ 過去月除外）
     ============================================================ */

  function monthsForCat(cat) {
    const set = new Set();
    allProducts.forEach(p => {
      if (!p.cols.includes(cat)) return;
      (p._periods || []).forEach(pr => {
        if (!pr.available) return;
        pr.months.forEach(ym => {
          if (isCurrentOrFutureYm(ym)) set.add(ym);
        });
      });
    });
    return [...set].sort();
  }

  function initPeriodPickers() {
    document.querySelectorAll('.period-picker-wrap').forEach(function (wrap) {
      const cat = wrap.dataset.cat;
      const months = monthsForCat(cat);
      if (months.length === 0) { wrap.style.display = 'none'; wrap.innerHTML = ''; return; }

      wrap.style.display = 'block';

      const byYear = [];
      months.forEach(ym => {
        const y = ymYear(ym);
        let bucket = byYear.find(b => b.year === y);
        if (!bucket) { bucket = { year: y, list: [] }; byYear.push(bucket); }
        bucket.list.push(ym);
      });

      let html = '';
      byYear.forEach(function (b) {
        html += '<div class="period-year">' +
          '<div class="period-year-title">' + escapeHtml(b.year) + '年</div>' +
          '<div class="period-chips">';
        b.list.forEach(function (ym) {
          html += '<button type="button" class="period-chip" data-cat="' + escapeHtml(cat) + '" data-ym="' + escapeHtml(ym) +
            '" aria-pressed="false">' + escapeHtml(ymShortLabel(ym)) + '</button>';
        });
        html += '</div></div>';
      });

      wrap.innerHTML = html;

      wrap.querySelectorAll('.period-chip').forEach(function (chip) {
        chip.addEventListener('click', function () {
          toggleMonth(chip.dataset.cat, chip.dataset.ym);
        });
      });
    });

    renderPeriodPickersState();
  }

  function toggleMonth(cat, ym) {
    const list = pendingFor(cat);
    const i = list.indexOf(ym);
    if (i === -1) list.push(ym);
    else list.splice(i, 1);
    renderPeriodPickersState();
  }

  // 期間チップの選択状態。モーダルで開いているタブ（ピッカーの data-cat）の選択中の月を出す
  function renderPeriodPickersState() {
    document.querySelectorAll('.period-picker-wrap').forEach(function (wrap) {
      const cat = wrap.dataset.cat;
      const on = new Set(pendingFor(cat));

      wrap.querySelectorAll('.period-chip').forEach(function (chip) {
        const isOn = on.has(chip.dataset.ym);
        chip.classList.toggle('is-on', isOn);
        chip.setAttribute('aria-pressed', isOn ? 'true' : 'false');
      });
    });
  }

  /* ============================================================
     用途クイックフィルタ（オプション表示時のみ）
     ============================================================ */

  function setUseFilter(useTag) {
    state.groups = state.groups.filter(g => !g.every(t => USE_TAGS.indexOf(t) !== -1));
    if (useTag) state.groups.push([useTag]);
    restorePanelState();
    applyFilters();
  }

  function currentUseFilter() {
    for (const g of state.groups) {
      if (g.length === 1 && USE_TAGS.indexOf(g[0]) !== -1) return g[0];
    }
    return '';
  }

  function renderQuickFilter() {
    const wrap = document.getElementById('use-quick-filter');
    if (!wrap) return;
    if (state.cat !== 'option' || state.planHandle) { wrap.style.display = 'none'; wrap.innerHTML = ''; return; }

    const active = currentUseFilter();
    let html = '<span class="use-quick-label">用途で絞る</span><div class="use-quick-btns">';
    html += '<button type="button" class="use-quick-btn' + (active === '' ? ' is-active' : '') + '" data-use="">すべて</button>';
    USE_TAGS.forEach(t => {
      const label = USE_LABELS[t] || t;
      html += '<button type="button" class="use-quick-btn' + (active === t ? ' is-active' : '') +
        '" data-use="' + escapeHtml(t) + '">' + escapeHtml(label) + '</button>';
    });
    html += '</div>';

    wrap.innerHTML = html;
    wrap.style.display = 'flex';

    wrap.querySelectorAll('.use-quick-btn').forEach(btn => {
      btn.addEventListener('click', function () {
        setUseFilter(btn.dataset.use || '');
      });
    });
  }

  /* ============================================================
     プラン文脈バナー（グループモード用）
     ============================================================ */

  function renderPlanBanner() {
    const box = document.getElementById('plan-context-banner');
    if (!box) return;
    if (!state.planHandle) { box.style.display = 'none'; box.innerHTML = ''; return; }

    box.style.display = 'flex';
    box.innerHTML =
      '<span class="plan-banner-text">「' + escapeHtml(state.planTitle) + '」でご利用いただけるオプションです</span>' +
      '<button type="button" class="plan-banner-clear">絞り込みを解除してすべて見る</button>';

    box.querySelector('.plan-banner-clear').addEventListener('click', function () {
      state.planHandle = null;
      state.planTitle = '';
      state.planOptHandles = [];
      state.planLoading = false;
      state.areas = [];
      state.groups = [];
      state.months = [];
      restorePanelState();
      applyFilters();
    });
  }

  /* ============================================================
     適用中の条件チップ
     ============================================================ */

  function renderActiveConditions() {
    const box = document.getElementById('active-conditions');
    if (!box) return;
    const chips = [];

    state.months.forEach(ym => chips.push({ kind: 'month', gi: -1, value: ym, label: ymLabel(ym) }));
    state.areas.forEach(a => chips.push({ kind: 'area', gi: -1, value: a, label: a }));
    state.groups.forEach((g, gi) => {
      g.forEach(t => chips.push({ kind: 'tag', gi: gi, value: t, label: USE_LABELS[t] || t }));
    });

    if (chips.length === 0) { box.style.display = 'none'; box.innerHTML = ''; return; }

    box.style.display = 'block';
    box.innerHTML =
      '<span class="cond-label">適用中の条件</span>' +
      chips.map(c =>
        '<button type="button" class="cond-chip" data-kind="' + c.kind + '" data-gi="' + c.gi + '" data-value="' + escapeHtml(c.value) + '">' +
        escapeHtml(c.label) + '<span class="cond-x" aria-hidden="true">×</span>' +
        '<span class="visually-hidden">を解除</span></button>'
      ).join('') +
      '<button type="button" class="cond-clear">すべて解除</button>';

    box.querySelectorAll('.cond-chip').forEach(chip => {
      chip.addEventListener('click', function () {
        removeCondition(chip.dataset.kind, parseInt(chip.dataset.gi, 10), chip.dataset.value);
      });
    });
    box.querySelector('.cond-clear').addEventListener('click', function () {
      state.areas = [];
      state.groups = [];
      state.months = [];
      restorePanelState();
      applyFilters();
    });
  }

  function removeCondition(kind, gi, value) {
    if (kind === 'month') {
      state.months = state.months.filter(ym => ym !== value);
    } else if (kind === 'area') {
      state.areas = state.areas.filter(a => a !== value);
    } else {
      const g = state.groups[gi];
      if (g) {
        const next = g.filter(t => t !== value);
        if (next.length === 0) state.groups.splice(gi, 1);
        else state.groups[gi] = next;
      }
    }
    restorePanelState();
    applyFilters();
  }

  /* ============================================================
     価格表示
     ============================================================ */

  function priceDisplayFor(p) {
    // 個別の$表記など、価格をそのまま出したい商品は price_override を使う
    if (p.price_override) return { text: p.price_override, from: false, compareText: null };

    // 月を選んでいるときは、該当するバリエーションの最安値を出す。
    // 平日と土日祝で価格が分かれている場合は平日価格が出て、「〜」が付く。
    if (state.months.length > 0 && p._periods && p._periods.length > 0) {
      const matched = matchingPeriods(p, state.months);
      if (matched.length > 0) {
        let cheapest = matched[0];
        let multiplePrices = false;
        matched.forEach(pr => {
          if (pr.price < cheapest.price) cheapest = pr;
          if (pr.price !== matched[0].price) multiplePrices = true;
        });
        return {
          text: cheapest.priceF,
          from: multiplePrices,
          compareText: (cheapest.compareAt && cheapest.compareAt > cheapest.price) ? cheapest.compareAtF : null
        };
      }
    }

    return {
      text: p.price_min,
      from: !!p.has_variants,
      compareText: (p.compare_at_min_raw && p.compare_at_min_raw > p.price_min_raw) ? p.compare_at_min : null
    };
  }

  /* ============================================================
     プランカード
     プラン一覧セクション（子コレクションページ）と同じ形。
     写真は横スクロール、キャンセル規定は1行固定（開閉なし）。
     ============================================================ */

  // 撮影内容のアイコン。プラン一覧セクションと同じSVG
  const POINT_ICONS = {
    loc: '<path d="M12 21s-7-6.2-7-11.5a7 7 0 0 1 14 0C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/>',
    deta: '<path d="M4 8h3l2-2.5h6L17 8h3a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z"/><circle cx="12" cy="13" r="3.5"/>',
    isho: '<path d="M12 8.5V7a2 2 0 1 0-2-2"/><path d="M12 8.5 3.5 15a1.5 1.5 0 0 0 .9 2.7h15.2a1.5 1.5 0 0 0 .9-2.7z"/>'
  };
  const SVG_OPEN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">';

  function planCardHtml(p) {
    const price = priceDisplayFor(p);
    const foundAreas = areaBadgeTitles(p);
    const foundIslands = p.tags.filter(t => islandTags.includes(t));
    const isRecommended = p.tags.includes('Recommended');
    const isCampaign = p.tags.includes('Campaign');
    const isLimited = p.tags.includes('期間限定');
    const safeTitle = escapeHtml(p.title);
    const safeUrl = escapeHtml(p.url);

    const imgs = (p.imgs && p.imgs.length > 0) ? p.imgs : (p.img ? [p.img] : []);

    const badgeHtml =
      '<div class="badge-corner">' +
      (isRecommended ? '<div class="badge-recommended">Recommended</div>' : '') +
      (isCampaign ? '<div class="badge-campaign">Campaign</div>' : '') +
      '</div>';

    let shotsHtml;
    if (imgs.length === 0) {
      shotsHtml = '<div class="plan-card-noimage">No Image</div>';
    } else {
      shotsHtml =
        '<div class="plan-card-shots">' +
        '<div class="plan-card-strip" tabindex="0" role="group" aria-label="' + safeTitle + 'の写真">' +
        imgs.map(function (src, i) {
          return '<a href="' + safeUrl + '" class="plan-card-shot">' +
            '<img src="' + escapeHtml(src) + '" loading="lazy" decoding="async" alt="' +
            (i === 0 ? safeTitle : safeTitle + ' 写真' + (i + 1)) + '">' +
            (i === 0 ? badgeHtml : '') +
            '</a>';
        }).join('') +
        '</div></div>';
    }

    // バッジ。並びはプラン一覧と同じ：カテゴリ → エリア → 本島／宮古島 → 期間限定 → 日本語アテンド付き
    const categoryTitles = [];
    p.cols.forEach((h, i) => {
      if (parentHandles.includes(h) && categoryTitles.indexOf(p.colTitles[i]) === -1) categoryTitles.push(p.colTitles[i]);
    });
    const categoryHtml = categoryTitles.map(t => '<span class="plan-card-tag plan-card-tag--category">' + escapeHtml(t) + '</span>').join('');

    let areaHtml = '';
    if (allAreaTitles.length > 0 && foundAreas.length >= allAreaTitles.length) {
      areaHtml = '<span class="plan-card-tag plan-card-tag--area">全エリア</span>';
    } else if (foundAreas.length > 3) {
      areaHtml = foundAreas.slice(0, 3).map(t => '<span class="plan-card-tag plan-card-tag--area">' + escapeHtml(t) + '</span>').join('') +
        '<span class="plan-card-tag plan-card-tag--area-more">他' + (foundAreas.length - 3) + '</span>';
    } else {
      areaHtml = foundAreas.map(t => '<span class="plan-card-tag plan-card-tag--area">' + escapeHtml(t) + '</span>').join('');
    }
    const islandHtml = foundIslands.map(t => '<span class="plan-card-tag plan-card-tag--island">' + escapeHtml(t) + '</span>').join('');
    const limitedHtml = isLimited ? '<span class="plan-card-tag plan-card-tag--limited">期間限定</span>' : '';
    const attendHtml = p.attend ? '<span class="plan-card-tag plan-card-tag--attend">日本語アテンド付き</span>' : '';
    const metaInner = categoryHtml + areaHtml + islandHtml + limitedHtml + attendHtml;
    const metaHtml = metaInner ? '<div class="plan-card-meta">' + metaInner + '</div>' : '';

    // キャッチ・おすすめ・撮影内容（プラン一覧と同じ）
    const catchHtml = p.catchText
      ? '<p class="plan-card-catch">' + escapeHtml(p.catchText) + '</p>'
      : '';

    const recoList = Array.isArray(p.reco) ? p.reco : [];
    const recoHtml = recoList.length > 0
      ? '<div class="plan-card-reco">' +
        '<span class="plan-card-reco-mark">' + SVG_OPEN + '<circle cx="12" cy="8" r="3.5"/><path d="M5 20a7 7 0 0 1 14 0"/></svg><span>おすすめ</span></span>' +
        '<ul class="plan-card-reco-list">' +
        recoList.map(t => '<li class="plan-card-reco-item">' + escapeHtml(t) + '</li>').join('') +
        '</ul></div>'
      : '';

    const pointList = Array.isArray(p.points) ? p.points : [];
    const pointsHtml = pointList.length > 0
      ? '<ul class="plan-card-points">' +
        pointList.map(pt =>
          '<li class="plan-card-point">' + SVG_OPEN + (POINT_ICONS[pt.k] || '') + '</svg>' +
          '<span>' + escapeHtml(pt.t) + '</span></li>'
        ).join('') +
        '</ul>'
      : '';

    // キャンセル規定はプラン一覧と同じく1行固定。agreeDown は使わない。
    const cancelHtml = p.agreeUp
      ? '<div class="plan-card-cancel">' +
        '<span class="plan-card-cancel-icon" aria-hidden="true">i</span>' +
        '<span class="plan-card-cancel-text">' + p.agreeUp + '</span>' +
        '</div>'
      : '';

    const labelHtml = PRICE_LABEL
      ? '<span class="plan-card-pricelabel">' + escapeHtml(PRICE_LABEL) + '</span>'
      : '';
    const compareHtml = price.compareText
      ? '<span class="plan-card-compare">' + escapeHtml(price.compareText) + '</span>'
      : '';

    return '' +
      '<article class="plan-card">' +
      '<h3 class="plan-card-title"><a href="' + safeUrl + '">' + safeTitle + '</a></h3>' +
      metaHtml +
      shotsHtml +
      catchHtml +
      recoHtml +
      pointsHtml +
      '<div class="plan-card-bottom">' +
      cancelHtml +
      '<div class="plan-card-foot">' +
      '<div class="plan-card-pricebox">' +
      labelHtml +
      compareHtml +
      '<p class="plan-card-price">' + escapeHtml(price.text) +
      (price.from ? '<span class="plan-card-from">〜</span>' : '') +
      '</p>' +
      '</div>' +
      '<a href="' + safeUrl + '" class="plan-card-cta">詳細を見る</a>' +
      '</div>' +
      '</div>' +
      '</article>';
  }

  /* ============================================================
     オプションカード（種類別グループ表示で使う）
     ============================================================ */

  function productCardHtml(p) {
    const price = priceDisplayFor(p);
    const priceDisplay = price.from ? (price.text + ' 〜') : price.text;
    const foundAreas = areaBadgeTitles(p);
    const foundUses = useBadgeTags(p);
    const foundIslands = p.tags.filter(t => islandTags.includes(t));
    const isRecommended = p.tags.includes('Recommended');
    const isCampaign = p.tags.includes('Campaign');
    const isLimited = p.tags.includes('期間限定');
    const safeTitle = escapeHtml(p.title);
    const safeUrl = escapeHtml(p.url);

    const imgHtml = p.img
      ? '<img src="' + escapeHtml(p.img) + '" loading="lazy" alt="' + safeTitle + '">'
      : '<div class="no-image-box">No Image</div>';

    const useHtml = foundUses
      .map(t => '<span class="' + (USE_CLASSES[t] || 'tag-use-other') + '">' + escapeHtml(USE_LABELS[t] || t) + '</span>')
      .join('');

    let areaHtml = '';
    if (allAreaTitles.length > 0 && foundAreas.length >= allAreaTitles.length) {
      areaHtml = '<span class="tag-area">全エリア</span>';
    } else if (foundAreas.length > 3) {
      areaHtml = foundAreas.slice(0, 3).map(t => '<span class="tag-area">' + escapeHtml(t) + '</span>').join('') +
        '<span class="tag-area-more">他' + (foundAreas.length - 3) + '</span>';
    } else {
      areaHtml = foundAreas.map(t => '<span class="tag-area">' + escapeHtml(t) + '</span>').join('');
    }

    // 二重価格。判定は priceDisplayFor() の compareText（プランカードと同じ）
    const compareHtml = price.compareText
      ? '<p class="compare-text">' + escapeHtml(price.compareText) + '</p>'
      : '';

    return '' +
      '<div class="product-item">' +
      '<a href="' + safeUrl + '" class="product-link">' +
      '<div class="img-wrapper">' + imgHtml +
      '<div class="badge-corner">' +
      (isRecommended ? '<div class="badge-recommended">Recommended</div>' : '') +
      (isCampaign ? '<div class="badge-campaign">Campaign</div>' : '') +
      '</div></div>' +
      '<div class="tag-list">' + useHtml + areaHtml +
      foundIslands.map(t => '<span class="tag-island">' + escapeHtml(t) + '</span>').join('') +
      (isLimited ? '<span class="tag-limited">期間限定</span>' : '') +
      '</div>' +
      '<p class="title-text">' + safeTitle + '</p>' +
      '<div class="price-box">' +
      compareHtml +
      '<p class="price-text">' + escapeHtml(priceDisplay) + '</p>' +
      '</div>' +
      '</a></div>';
  }

  /* ============================================================
     結果描画
     ============================================================ */

  function renderResults(results) {
    // 価格の安い順。ソートは price_override の有無に関わらず実際の価格を使う
    const sortedResults = [...results].sort((a, b) => a.price_min_raw - b.price_min_raw);

    const container = document.getElementById('search-results-container');
    const header = document.getElementById('results-header');
    const nav = document.getElementById('type-nav');

    if (!container || !header) return;

    header.textContent = sortedResults.length === 0 ? '検索結果（0件）' : '検索結果（' + sortedResults.length + '件見つかりました）';

    if (sortedResults.length === 0) {
      container.className = 'plan-grid fade-in';
      if (nav) { nav.style.display = 'none'; nav.innerHTML = ''; }
      container.innerHTML = '<p style="text-align:center; padding:20px; color:#8e7a68;">該当するものはありませんでした。</p>';
      return;
    }

    // オプション表示のときだけ種類別グループ表示に切り替える
    if (state.cat === 'option') {
      container.className = 'grouped-results fade-in';
      renderGroupedResults(sortedResults, container, nav);
    } else {
      container.className = 'plan-grid fade-in';
      if (nav) { nav.style.display = 'none'; nav.innerHTML = ''; }
      container.innerHTML = sortedResults.map(planCardHtml).join('');
    }
  }

  function renderGroupedResults(sortedResults, container, nav) {
    // TYPE_TAGS の定義順にグループを組む。各グループ内の並びは価格の安い順のまま
    const buckets = new Map();
    TYPE_TAGS.forEach(t => buckets.set(t, []));
    sortedResults.forEach(p => {
      const t = typeOf(p);
      if (!buckets.has(t)) buckets.set(t, []);
      buckets.get(t).push(p);
    });

    const visible = TYPE_TAGS
      .map((t, i) => ({ type: t, items: buckets.get(t) || [], id: 'type-group-' + i }))
      .filter(g => g.items.length > 0);

    if (nav) {
      nav.style.display = visible.length > 1 ? 'flex' : 'none';
      nav.innerHTML = visible.length > 1
        ? visible.map(g =>
          '<button type="button" class="type-nav-btn" data-target="' + g.id + '">' +
          escapeHtml(g.type) + '<span class="type-nav-count">' + g.items.length + '</span></button>'
        ).join('')
        : '';
    }

    container.innerHTML = visible.map(g =>
      '<section class="type-group" id="' + g.id + '">' +
      '<h4 class="type-group-title">' + escapeHtml(g.type) +
      '<span class="type-group-count">' + g.items.length + '件</span></h4>' +
      '<div class="product-grid">' + g.items.map(productCardHtml).join('') + '</div>' +
      '</section>'
    ).join('');

    if (nav) {
      nav.querySelectorAll('.type-nav-btn').forEach(btn => {
        btn.addEventListener('click', function () {
          const target = document.getElementById(btn.dataset.target);
          if (target) target.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
        });
      });
    }
  }

  // onclick="..." から呼べるように、テーマのグローバルスコープに公開する
  window.toggleFilterMenu = toggleFilterMenu;
  window.switchSearchCategory = switchSearchCategory;
  window.selectCategory = selectCategory;
  window.backToCategories = backToCategories;
  window.executeAdvancedSearch = executeAdvancedSearch;
})();